import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loginSuccess } from "../../redux/auth/authSlice";
import service from "../../services/service";
import endpoints from "../../services/endpoints";
import "./Login.css";
import { Logo } from "../../assests/ExportImageIcon";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await service.post(endpoints.auth.login, form);
      const data = res.data?.data;
      setShowSuccess(true);
      setTimeout(() => {
        dispatch(loginSuccess({
          user: data.user,
          access_token: data.tokens.access,
          refresh_token: data.tokens.refresh,
          role: data.user?.role || null,
        }));
        navigate("/dashboard");
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.message || "Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {showSuccess && (
        <div className="success-overlay">
          <div className="success-modal">
            <div className="success-icon">✓</div>
            <h3>Login Successful!</h3>
            <p>Redirecting to dashboard...</p>
          </div>
        </div>
      )}

      <div className="login-container">
        <div className="login-card">
          <img src={Logo} className="logo"/>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
              />
            </div>

            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                name="password"
                value={form.password}
                onChange={handleChange}
                placeholder="Enter your password"
                required
              />
            </div>

            {error && <p className="login-error">{error}</p>}
            <div className="forgotPass" onClick={() => navigate("/forgot-password")}>Forgot Password?</div>

            <button type="submit" className="commonOrngBtn" disabled={loading}>
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default Login;
